import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';

export interface SocialIcon {
	url: string;
	name: string;
}

export interface ISocialIconsProps extends IBaseElementProps {
	icons?: SocialIcon[];
	openInPopup?: boolean;
}

const SocialIcons: React.FC<ISocialIconsProps> = ({
	className,
	openInPopup = false,
	classNames = [],
	icons = [],
}) => {
	return (
		<ul className={className || cn('social-icons', ...classNames)}>
			{icons.map(({ name, url }) => {
				const check_name = name.toLowerCase();
				let _url = url;
				if (['email', 'mail'].indexOf(check_name) !== -1) {
					_url = 'mailto:' + url.toLowerCase().replace('mailto:', '');
				}
				return (
					<li key={name}>
						<a
							href={_url}
							target="_blank"
							aria-label={name}
							className="share-icon-link"
							onClick={(e) => {
								if (openInPopup && !_url.includes('mailto:')) {
									e.preventDefault();
									window.open(
										_url,
										'_blank',
										'popup,width=600,height=600',
									);
								}
							}}
						>
							<Icon name={name.toLowerCase()} />
						</a>
					</li>
				);
			})}
		</ul>
	);
};

export default SocialIcons;
